import React from "react";

const SocialLinks = ({ links }) => {
  return (
    <div className="social-container">
      {links.map((link) => (
        <a
          key={link.name}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={link.name}
          className="social-button"
        >
          <img src={link.icon} alt={link.name} />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;